import type { UniversitySchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { universitySchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import Container from '$/components/elements/Container';
import AutocompleteInputQuestion from '$/components/elements/Questions/AutocompleteInputQuestion';
import * as queries from '$/graphql/queries';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

const University = () => {
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const { control, handleSubmit } = useForm<UniversitySchemaType>({
    mode: 'onChange',
    resolver: yupResolver(universitySchema),
    defaultValues: state,
  });

  const onSubmit = (payload: UniversitySchemaType) => {
    dispatch({
      type: 'set',
      payload,
    });
    setCurrentStep('expectedDegree');
  };

  return (
    <StudentQuestion noLimitHeight>
      <Container>
        <AutocompleteInputQuestion
          control={control}
          name={'university'}
          title={'An welcher Hochschule?'}
          placeholder={'Hochschule suchen'}
          query={queries.highSchoolAutoComplete}
          defaultSearch={state.city?.[0]?.value}
          onValueSelected={handleSubmit(onSubmit)}
          maxElements={8}
          searchedFieldElbAction={TRACKING_ACTION.REGISTRATION.HIGH_SCHOOL}
        />
      </Container>
    </StudentQuestion>
  );
};

export default University;
